export const ERROR_CODE_MAP: Readonly<Record<string, string>> = {
  NOT_FOUND: 'The requested resource was not found.',
  DUPLICATE_SUBMISSION: 'A submission already exists for this period.',
  HOURS_MISMATCH: "The hours entered don't match the expected total.",
  MISSING_TIMESHEETS: 'Some timesheets are missing. Please check and try again.',
  REASON_REQUIRED: 'A reason is required to proceed.',
  TIMESHEET_IMAGE_REQUIRED: 'A timesheet image is required.',
  TIMESHEET_IMAGE_MISSING: 'One or more timesheet images are missing.',
  TIMESHEET_IMAGE_COUNT_MISMATCH: "The number of timesheet images doesn't match.",
  TIMESHEET_ASSESSMENT_FAILED: 'Timesheet assessment failed. Please try again.',
  TRUSTED_TIMESHEET_ENTRIES_NOT_FOUND:
    'Failed to fetch timesheet entries from Keka. Please try again.',
  FILE_SIZE_TOO_LARGE: 'The file is too large. Please upload a smaller file.',
  UNSUPPORTED_FILE_TYPE: 'This file type is not supported.',
  INVALID_ACTION: 'This action is not allowed at this stage.',
  INVALID_TRANSITION: 'This status change is not allowed.',
  CANNOT_CREATE_SELF_HIERARCHY: 'You cannot add yourself to your own reporting hierarchy.',
  // API sends USER_ALREADY_EXIST (not EXISTS) — matches backend contract
  USER_ALREADY_EXIST: 'A user with this information already exists.',
  MESHCOMM_TIMEOUT: 'The request timed out. Please try again.',
  MESHCOMM_CONNECTION_ERROR: 'Could not connect to the service. Please try again.',
  MESHCOMM_REQUEST_ERROR: 'An error occurred with the request. Please try again.',
  MESHCOMM_EMAIL_FAILED: 'Failed to send email notification.',
  MESHCOMM_INVALID_RESPONSE: 'Received an unexpected response from the service.',
  MESHDOC_TIMEOUT: 'The request timed out. Please try again.',
  MESHDOC_CONNECTION_ERROR: 'Could not connect to the service. Please try again.',
  MESHDOC_REQUEST_ERROR: 'An error occurred with the request. Please try again.',
  MESHDOC_FILE_NOT_FOUND: 'The requested file was not found.',
  MESHDOC_IMAGE_FETCH_FAILED: 'Failed to load the image.',
  MESHDOC_UPLOAD_FAILED: 'File upload failed. Please try again.',
  MSAL_AUTH_FAILED: 'Authentication failed. Please sign in again.',
  INTERNAL_SERVER_ERROR: 'Server error. Please try again later.',
  VALIDATION_ERROR: 'Validation failed. Please check your input.',
};

export function resolveErrorMessage(status: number, code?: string): string {
  if (code && Object.hasOwn(ERROR_CODE_MAP, code)) {
    return ERROR_CODE_MAP[code];
  }

  switch (status) {
    case 400:
      return 'Invalid request. Please check your input.';
    case 404:
      return 'The requested resource was not found.';
    case 408:
      return 'The request timed out. Please try again.';
    case 409:
      return 'A conflict occurred. Please refresh and try again.';
    case 422:
      return 'Validation failed. Please check your input.';
    case 429:
      return 'Too many requests. Please slow down.';
    case 500:
      return 'Server error. Please try again later.';
    case 502:
    case 503:
    case 504:
      return 'Service unavailable. Please try again later.';
    default:
      return 'Something went wrong. Please try again.';
  }
}
